import OrderDetails from './order-details';

export default OrderDetails;